module.exports = __webpack_public_path__ + "img/time.e012ddb1.svg";